import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './PaymentStyles.css';

function PaymentGateway() {
  const navigate = useNavigate();
  const location = useLocation();
  const { paymentType, amount, itemId, title, returnPath } = location.state || {};
  const [paymentData, setPaymentData] = useState({
    cardNumber: '',
    expDate: '',
    cvc: '',
    name: '',
    email: ''
  });
  const [isProcessing, setIsProcessing] = useState(false);
  const [error, setError] = useState('');

  // Handle input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPaymentData({
      ...paymentData,
      [name]: value
    });
  };

  // Format card number with spaces
  const formatCardNumber = (value) => {
    const v = value.replace(/\s+/g, '').replace(/[^0-9]/gi, '');
    const matches = v.match(/\d{4,16}/g);
    const match = (matches && matches[0]) || '';
    const parts = [];
    
    for (let i = 0; i < match.length; i += 4) {
      parts.push(match.substring(i, i + 4));
    }
    
    if (parts.length) {
      return parts.join(' ');
    } else {
      return value;
    }
  };

  // Handle card number change with formatting
  const handleCardNumberChange = (e) => {
    const formattedValue = formatCardNumber(e.target.value);
    setPaymentData({
      ...paymentData,
      cardNumber: formattedValue
    });
  };

  // Handle payment submission
  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    
    // Immediately process the payment without any validation
    setIsProcessing(true);
    
    // Simulate payment processing
    setTimeout(() => {
      setIsProcessing(false);
      
      // Redirect based on payment type
      if (paymentType === 'wtb') {
        navigate('/wtb', { 
          state: { 
            paymentSuccess: true, 
            message: 'Your WTB request has been posted successfully!' 
          } 
        });
      } else if (paymentType === 'auction') {
        navigate(`/listing/${itemId}`, { 
          state: { 
            paymentSuccess: true, 
            message: 'Your bid has been placed successfully!' 
          } 
        });
      } else {
        navigate(returnPath || '/');
      }
    }, 2000);
  };

  // Determine payment description
  const getPaymentDescription = () => {
    if (paymentType === 'wtb') {
      return 'WTB Request Fee';
    } else if (paymentType === 'auction') {
      return `Bid on ${title}`;
    }
    return 'Payment';
  };

  return (
    <div className="payment-page">
      <div className="payment-container">
        <div className="payment-header">
          <h1>Secure Payment</h1>
          <p>{getPaymentDescription()}</p>
        </div>

        <div className="payment-amount">
          <span className="amount-label">Amount:</span>
          <span className="amount-value">HK${amount}</span>
        </div>

        {error && <div className="payment-error">{error}</div>}

        <form className="payment-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              name="email"
              placeholder="email@example.com"
              value={paymentData.email}
              onChange={handleInputChange}
            />
          </div>

          <div className="form-group">
            <label>Cardholder Name</label>
            <input
              type="text"
              name="name"
              placeholder="Name on card"
              value={paymentData.name}
              onChange={handleInputChange}
            />
          </div>

          <div className="form-group">
            <label>Card Number</label>
            <div className="card-input-container">
              <input
                type="text"
                name="cardNumber"
                placeholder="1234 5678 9012 3456"
                value={paymentData.cardNumber}
                onChange={handleCardNumberChange}
                maxLength="19"
              />
              <div className="card-icons">
                <span>💳</span>
              </div>
            </div>
          </div>

          <div className="form-row">
            <div className="form-group half">
              <label>Expiration Date</label>
              <input
                type="text"
                name="expDate"
                placeholder="MM/YY"
                value={paymentData.expDate}
                onChange={handleInputChange}
                maxLength="5"
              />
            </div>
            <div className="form-group half">
              <label>CVC</label>
              <input
                type="text"
                name="cvc"
                placeholder="123"
                value={paymentData.cvc}
                onChange={handleInputChange}
                maxLength="4"
              />
            </div>
          </div>

          <button 
            type="submit" 
            className="payment-button"
            disabled={isProcessing}
          >
            {isProcessing ? 'Processing...' : 'Pay Now'}
          </button>
        </form>

        <div className="payment-footer">
          <div className="secure-notice">
            <span className="lock-icon">🔐</span>
            Secured with 256-bit encryption
          </div>
        </div>
      </div>
    </div>
  );
}

export default PaymentGateway; 